import { createFileRoute } from "@tanstack/react-router";
import CultivationCheck from "../../app/views/cultivation/cultivationCheck";

const Component = () => <CultivationCheck cultivationType="pcr" />;

export const Route = createFileRoute("/pcr/check")({
  component: Component,
});
